// src/components/TeamSection.js
import React from 'react';
import TeamMemberCard from './TeamMemberCard';

const TeamSection = ({ members }) => {
  return (
    <div>
      <h3 className="text-xl sm:text-2xl font-bold text-center text-white mb-2 sm:mb-3">
        Nuestro <span className="text-[#FFD700]">Equipo</span>
      </h3>
      <p className="text-xs sm:text-sm text-center text-gray-400 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
        Profesionales comprometidos con su éxito, listos para brindar el mejor acompañamiento contable y estratégico.
      </p>
      
      {/* Grid: 1 columna en móvil, 2 columnas en desktop */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {members.map((member) => (
          <TeamMemberCard key={member.id} member={member} />
        ))}
      </div>
      
      <div className="text-center mt-8">
        <p className="inline-flex items-center gap-2 bg-black px-4 sm:px-5 py-2 rounded-full shadow text-gray-400 text-xs sm:text-sm border border-gray-800">
          <span className="text-[#FFD700] text-base sm:text-lg">+</span>
          Nuestro equipo sigue creciendo para servirle mejor
        </p>
      </div>
    </div>
  );
};

export default TeamSection;